import { colors } from '@theme/foundations/colors';
import { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const flightPlanFillLayer: FillLayerSpecification = {
  id: LayerNameEnum.FLIGHT_PLAN_FILLS,
  type: 'fill',
  source: SourceNameEnum.FLIGHT_PLANS,
  filter: ['==', 'featureType', FeatureTypeEnum.FLIGHT_PLAN],
  paint: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'selected'], false],
      colors.skyBlue['500'].value,
      colors.blue['500'].value,
    ],
    'fill-opacity': 0.5,
  },
};

export const flightPlanOutlineLayer: LineLayerSpecification = {
  id: LayerNameEnum.FLIGHT_PLAN_OUTLINES,
  type: 'line',
  source: SourceNameEnum.FLIGHT_PLANS,
  filter: ['==', 'featureType', FeatureTypeEnum.FLIGHT_PLAN],
  paint: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'selected'], false],
      colors.skyBlue['500'].value,
      colors.blue['500'].value,
    ],
    'line-opacity': 1,
    'line-width': 4,
  },
};

export const intersectionFillLayer: FillLayerSpecification = {
  id: LayerNameEnum.FLIGHT_PLAN_INTERSECTION_FILLS,
  type: 'fill',
  source: SourceNameEnum.FLIGHT_PLAN_INTERSECTIONS,
  paint: {
    'fill-color': colors.orange['500'].value,
    'fill-opacity': 1,
    'fill-pattern': 'pattern_conflictZone',
  },
};

export const intersectionOutlineLayer: LineLayerSpecification = {
  id: LayerNameEnum.FLIGHT_PLAN_INTERSECTION_OUTLINES,
  type: 'line',
  source: SourceNameEnum.FLIGHT_PLAN_INTERSECTIONS,
  paint: {
    'line-color': colors.orange['500'].value,
    'line-opacity': 1,
    'line-width': 4,
  },
};
